<template>
  <div class="aside" v-bind:style="{ height: asideHeight + 'px' }" v-if="oidcUser">
    <div class="myaccount">
      <div class="mc-header">
        <h4>My Account</h4>
        <span class="ma-close-btn" @click="toggleAsidebar">
          <b-icon-x></b-icon-x>
        </span>
      </div>
      <div class="ma-body d-flex">
        <div class="ma-profile-pic">
          <img src="../assets/images/sandy.jpg" class="user-image" alt="User Image" />
        </div>
        <div class="ma-profile">
          <h5>{{oidcUser.unique_name}}</h5>
          <p>{{oidcUser.email}}</p>
        </div>
      </div>
      <div class="p-4">
        <div class="list-group list-group-flush ma-liks">
          <a href="#" class="list-group-item list-group-item-action">
            <span class="ma-linksicon">
              <b-icon icon="person-square"></b-icon>
            </span> Profile
          </a>
          <a href="#" class="list-group-item list-group-item-action">
            <span class="ma-linksicon">
              <b-icon icon="app-indicator"></b-icon>
            </span> Change Password
          </a>
          <a href="#" @click="logout" class="list-group-item list-group-item-action">
            <span class="ma-linksicon">
              <b-icon icon="lock-fill"></b-icon>
            </span>Logout
          </a>
        </div>
        <!-- <div class="theme-app pt-3">
          <h5>Theme Setting</h5>
          <themeswitcher />
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
// import themeswitcher from "./ThemeSwitcher";
import { mapGetters } from "vuex";

export default {
  components: {
    // themeswitcher
  },
  name: "asside",
  data: function() {
    return {
      asideHeight: 400
    };
  },
  methods: {
    toggleAsidebar: function() {
      this.$root.$emit("flyoutAsidebar");
      this.showAsidebar = !this.showAsidebar;
    },
    logout() {
      this.$store.dispatch("oidcStore/signOutOidc");
      // this.$store.dispatch("oidcStore/removeOidcUser");
    },
    handleResize: function() {
      this.asideHeight = window.innerHeight;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"])
  }
};
</script>
